import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.5 4.25a.75.75 0 0 0-.75-.75h-3.5a.75.75 0 0 0-.75.75V5h5zM16 5v-.75A2.25 2.25 0 0 0 13.75 2h-3.5A2.25 2.25 0 0 0 8 4.25V5H4a.75.75 0 0 0 0 1.5h.5v13.25A2.25 2.25 0 0 0 6.75 22h10.5a2.25 2.25 0 0 0 2.25-2.25V6.5h.499a.75.75 0 0 0 0-1.5H16m2 4.896V6.5H6v13.25c0 .414.336.75.75.75h10.5a.75.75 0 0 0 .75-.75V9.896M9.25 16.5v-6a.75.75 0 0 1 1.5 0v6a.75.75 0 0 1-1.5 0m4-6v6a.75.75 0 0 0 1.5 0v-6a.75.75 0 0 0-1.5 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }